<template>
    <base-modal
        title="Información del curso"
        size="lg"
        :show-default-footer="false"
        @close="close"
    >
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="center-img-vertical">
                    <small>{{ categoriesText }}</small>
                    <img :src="course.image" alt="" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 p-4">
                <h3>{{ course.name }}</h3>
                <ul class="nav nav-pills mb-3 col-12 rounded bg-white px-0 py-3" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button 
                            class="nav-link" 
                            :class="{ active: activeTab === 'description' }"
                            @click="activeTab = 'description'"
                            type="button"
                        >
                            <strong>Descripción</strong>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button 
                            class="nav-link" 
                            :class="{ active: activeTab === 'overview' }"
                            @click="activeTab = 'overview'"
                            type="button"
                        >
                            <strong>Visión general</strong>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button 
                            class="nav-link" 
                            :class="{ active: activeTab === 'syllabus' }"
                            @click="activeTab = 'syllabus'"
                            type="button"
                        >
                            <strong>Temario</strong>
                        </button>
                    </li>
                </ul>
                
                <div class="tab-content">
                    <div v-show="activeTab === 'description'">
                        <p>{{ strippedContent }}</p>
                    </div>
                    
                    <div v-show="activeTab === 'overview'">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td class="text-start"><i class="fa fa-file"></i> Lecciones</td>
                                    <td class="text-end">{{ lessonsCount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-start"><i class="fa fa-puzzle-piece"></i> Cuestionarios</td>
                                    <td class="text-end">{{ quizzesCount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-start"><i class="fa fa-clock"></i> Duración</td>
                                    <td class="text-end">{{ course.duration }}</td>
                                </tr>
                                <tr>
                                    <td class="text-start"><i class="fa fa-users"></i> Estudiantes</td>
                                    <td class="text-end">{{ course.count_students }}</td>
                                </tr>
                                <tr>
                                    <td class="text-start"><i class="fa fa-check-square"></i> Evaluaciones</td>
                                    <td class="text-end">{{ hasQuizzes ? 'Sí' : 'No' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div v-show="activeTab === 'syllabus'">
                        <table class="table">
                            <tbody>
                                <tr v-for="(item, index) in syllabusItems" :key="index">
                                    <td 
                                        v-if="item.isSection" 
                                        class="text-primary text-start" 
                                        colspan="3"
                                    >
                                        <strong>{{ item.title }}</strong>
                                    </td>
                                    <template v-else>
                                        <td><i :class="item.icon"></i> {{ item.index }}</td>
                                        <td>{{ item.title }}</td>
                                        <td>{{ item.duration }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
        <template #footer>
            <button 
                type="button" 
                class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8" 
                @click="addCourse"
            >
                Agregar curso a ruta
            </button>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'ModalInfoCourse',
    components: { BaseModal },
    props: {
        course: { type: Object, required: true }
    },
    data() {
        return {
            activeTab: 'description'
        };
    },
    computed: {
        strippedContent() {
            return this.course.content?.replace(/<[^>]+>/g, '') || '';
        },
        categoriesText() {
            return this.course.categories?.map(cat => cat.name).join(', ') || '';
        },
        lessonsCount() {
            return this.countItemsByType('lp_lesson');
        },
        quizzesCount() {
            return this.countItemsByType('lp_quiz');
        },
        hasQuizzes() {
            return this.quizzesCount > 0;
        },
        syllabusItems() {
            const items = [];
            let sectionIndex = 1;
            
            this.course.sections?.forEach(section => {
                items.push({
                    isSection: true,
                    title: section.title,
                    index: `${sectionIndex}.`
                });
                
                let itemIndex = 1;
                section.items?.forEach(item => {
                    const isLesson = item.type === 'lp_lesson';
                    items.push({
                        isSection: false,
                        title: item.title,
                        duration: item.duration || '',
                        index: `${isLesson ? 'Lección' : 'Quiz'} ${sectionIndex}.${itemIndex}.`,
                        icon: `fa fa-${isLesson ? 'file' : 'puzzle-piece'}`
                    });
                    itemIndex++;
                });
                sectionIndex++;
            });
            
            return items;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        addCourse() {
            this.$emit('setCourse', this.course);
        },
        countItemsByType(type) {
            let count = 0;
            this.course.sections?.forEach(section => {
                section.items?.forEach(item => {
                    if (item.type === type) count++;
                });
            });
            return count;
        }
    }
};
</script>

<style scoped>
@media (min-width: 960px) {
    .center-img-vertical {
        position: relative;
        top: 15%;
    }
}

.nav-pills .nav-link.active {
    background-color: #4000BC;
}
</style>